const styles = (theme) => ({
  dataGrid: {
    border: `1px solid ${theme.AppBGColor}`,
    "& .ag-theme-material .ag-body-horizontal-scroll": {
      borderWidth: "0px",
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: "100%",
    },
    "& .statusBar": {
      display: "none",
    },
    [`& .theme-modernLight .ag-row-selected`]: {
      backgroundColor: "#edf7f7",
    },
    "& .ag-center-cols-viewport": {
      width: `calc(100% + 18px)`,
    },
  },
  rightHeaderControls: {},
  iconStyle: {
    color: theme.ErrorMessageColor,
    cursor: "pointer",
    fontSize: 18,
    padding: 2,
    marginLeft: 8,
  },
  headerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    border: `1px solid ${theme.AppBGColor}`,
    padding: 8,
    borderRadius: "4 4 0 0",
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
});

export default styles;
